module.exports = __webpack_public_path__ + "fonts/MavenPro-Medium.f01a3baa.ttf";